import * as React from 'react';

function SvgErrorAlt(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 23.9" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M22.4 6c1.1 1.8 1.6 3.9 1.6 6s-.5 4.2-1.6 6c-1.1 1.8-2.6 3.3-4.4 4.4-1.8 1.1-3.9 1.7-6 1.6-2.1 0-4.2-.5-6-1.6-1.8-1.1-3.3-2.6-4.4-4.4C.5 16.2 0 14.1 0 12s.6-4.2 1.6-6c1-1.8 2.6-3.3 4.4-4.4C7.8.5 9.9 0 12 0s4.2.5 6 1.6c1.8 1 3.3 2.5 4.4 4.4zm-.9 7.5v-3c0-.4-.2-.8-.4-1.1-.3-.3-.6-.4-1-.4H3.8c-.3 0-.7.1-.9.4-.3.3-.4.7-.4 1.1v3c0 .8.6 1.5 1.4 1.5h16.3c.7 0 1.3-.7 1.3-1.5z" />
    </svg>
  );
}

const MemoSvgErrorAlt = React.memo(SvgErrorAlt);
export default MemoSvgErrorAlt;
